import gql from 'graphql-tag';

// Batched variant used by list surfaces: one query for many cases so the submission badges
// avoid a per-row getSubmissionStatusByCase query/poll N+1. Requests the fields the list badge
// and shouldShowSubmissionInFlight need (status + recency timestamps).
const GET_SUBMISSION_STATUSES_BY_CASES = gql`
  query getSubmissionStatusesByCases($caseExternalIds: [String!]!) {
    getSubmissionStatusesByCases(caseExternalIds: $caseExternalIds) {
      submissionId
      caseExternalId
      status
      deadLettered
      createdAt
      updatedAt
    }
  }
`;

export default GET_SUBMISSION_STATUSES_BY_CASES;
